import React, { useEffect, useState } from "react";
import Edit from "../../Assets/img/Edit.svg";
import { useNavigate } from "react-router-dom";
import View from "../../Assets/img/Eye.svg";
import "../Services/Services.css";
import Search from "../../Assets/img/search.png";
import Delet from "../../Assets/img/Delete.svg";
import API from "../Service/Baseservice";
import Loading from "../../Loading/loading";

const Services = () => {
    const navigate = useNavigate();

    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [languageId, setLanguageId] = useState(1);

    // Redirect Map
    const redirectMap = {
        "banner": "banneredit",
        "bannière": "banneredit",

        "our gallery": "ourgallery",
        "notre galerie": "ourgallery",

        "why choose us": "whychooseusedit",
        "pourquoi nous choisir": "whychooseusedit",

        "how its works": "howitworkedit",
        "comment ça marche": "howitworkedit",

        "our service": "ourservices",
        "notre service": "ourservices",
    };


    // Normalize service name
    const normalize = (str) =>
        str.replace(/\s+/g, " ").trim().toLowerCase();

    // Fetch Services
    const fetchServices = () => {
        setLoading(true); // Start loader

        let payload = { search, status, language_id: languageId, };

        API.post("service_list/condition", payload)
            .then((response) => {
                const list = response?.data?.data?.data || [];

                const updatedList = list.map((item) => {
                    const key = normalize(item.service_name);
                    return {
                        ...item,
                        redirect: redirectMap[key] || "",
                        ourservice_id: item.ourservice_id
                    };
                });

                setServices(updatedList);
            })
            .catch((err) => {
                console.error("Error:", err);
                setServices([]);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchServices();
    }, []);

    const handleToggleStatus = (id, currentStatus) => {
        const newStatus = currentStatus === "active" ? "inactive" : "active";

        setLoading(true);

        API.post("service_status/update", {
            service_id: id,
            status: newStatus,
        })
            .then(() => fetchServices())
            .catch((err) => console.error("Failed to update status:", err))
            .finally(() => setLoading(false));
    };

    const isBanner = (name) => {
        const n = normalize(name);
        return n === "banner" || n === "bannière";
    };
    const ourServiceMap = {
        1: { 5: 1 },    // English → service_id:ourservice_id
        2: { 10: 2 },   // French → service_id:ourservice_id
    };
    const bannerServices = services.filter((item) =>
        isBanner(item.service_name)
    );

    const otherServices = services.filter((item) =>
        !isBanner(item.service_name)
    );
    return (
        <div className="services-container1">


            <div className="services-header1">
                <h2 className="services-title1">Services</h2>


            </div>


            <div className="category-filter-row1">
                <div className="category-filter-block1">
                    <label>Search By</label>
                    <div className="category-input-container1">
                        <input
                            placeholder="Search Services..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="category-input-field1"
                        />
                    </div>
                </div>

                <div className="category-filter-block1">
                    <label>Status</label>
                    <div className="category-input-container1">
                        <select
                            className="category-input-field1"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                        >
                            <option value="">Select Status</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </select>
                    </div>
                </div>

                <div className="filter-block">
                    <label>Language</label>
                    <div className="input-container">
                        <select
                            onChange={(e) => {
                                setLanguageId(Number(e.target.value));
                            }}
                            value={languageId}
                            className="input-field"
                        >
                            <option value="1">English</option>
                            <option value="2">Français</option>
                        </select>
                    </div>
                </div>

                <div
                    className="filter-btn-wrapper"
                    onClick={() => fetchServices()}
                >
                    <img src={Search} alt="Filter" className="icon-btnf" />
                </div>
            </div>

            {loading ? (
                <Loading />
            ) : (
                <>
                    {/* BANNER CARD */}
                    {bannerServices.length > 0 && (
                        <div className="services-grid2">
                            {bannerServices.map((item) => (
                                <div className="services-card1" key={item.service_id}>
                                    <p>{item.service_name}</p>

                                    <div className="card-footer1">
                                        <div className="status-container">
                                            <label className="category-switch">
                                                <input
                                                    type="checkbox"
                                                    checked={item.status === "active"}
                                                    onChange={() =>
                                                        handleToggleStatus(item.service_id, item.status)
                                                    }
                                                />
                                                <span className="category-slider round">
                                                    <span className="category-switch-label">
                                                        {item.status === "active" ? "ON" : "OFF"}
                                                    </span>
                                                </span>
                                            </label>
                                        </div>

                                        <div className="action-buttons1">
                                            <img
                                                src={Edit}
                                                alt="Edit"
                                                className="icon-btn1"
                                                onClick={() => navigate("/banneredit")}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}


                    {/* OTHER SERVICES */}
                    {otherServices.length > 0 && (
                        <div className="services-grid3">
                            {otherServices.map((item) => (
                                <div className="services-card1" key={item.service_id}>
                                    <p>{item.service_name}</p>

                                    <div className="card-footer1">
                                        <div className="status-container">
                                            <label className="category-switch">
                                                <input
                                                    type="checkbox"
                                                    checked={item.status === "active"}
                                                    onChange={() =>
                                                        handleToggleStatus(
                                                            item.service_id,
                                                            item.status
                                                        )
                                                    }
                                                />
                                                <span className="category-slider round">
                                                    <span className="category-switch-label">
                                                        {item.status === "active" ? "ON" : "OFF"}
                                                    </span>
                                                </span>
                                            </label>
                                        </div>

                                        <div className="action-buttons1">
                                            <img
                                                src={Edit}
                                                alt="Edit"
                                                className="icon-btn1"
                                                onClick={() => {
                                                    if (item.redirect === "ourgallery") {
                                                        navigate(`/ourgalleryedit/${item.service_id}?lang=${languageId}`);
                                                        return;
                                                    }

                                                    if (item.redirect === "ourservices") {
                                                        const ourserviceId =
                                                            ourServiceMap[languageId]?.[item.service_id];

                                                        if (!ourserviceId) {
                                                            alert("No ourservice_id found for this service");
                                                            return;
                                                        }

                                                        navigate(`/ourservices/${ourserviceId}?lang=${languageId}`);
                                                        return;
                                                    }

                                                    if (item.redirect === "howitworkedit") {
                                                        navigate(`/howitworkedit/${item.service_id}?lang=${languageId}`);
                                                        return;
                                                    }

                                                    if (item.redirect === "whychooseusedit") {
                                                        navigate(`/whychooseusedit/${item.service_id}?lang=${languageId}`);
                                                        return;
                                                    }

                                                    navigate(`/${item.redirect}`);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* NO DATA MESSAGE */}
                    {bannerServices.length === 0 && otherServices.length === 0 && (
                        <p className="no-news-text">No Services found.</p>
                    )}

                </>
            )}
        </div>
    );
};

export default Services;
